import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

type CityProps = {
  index1: number
  index2: number
}

export const City = ({ index1, index2 }: CityProps) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.city`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="12. City"
          input={(props) => <TextInput {...props} disabled={isAllInfoUnavailable} maxLength={50} />}
        />
      )}
    />
  )
}
